// extracted by mini-css-extract-plugin
module.exports = {"card":"Indicator_card__2fgBF","cardHeading":"Indicator_cardHeading__1lqPJ","cardTitle":"Indicator_cardTitle__2Q9Vr","cardBody":"Indicator_cardBody__cv4tt"};